import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientsPage from "@/pages/admin/ClientsPage";

export const Route = createFileRoute("/_admin/admin/clients/")({
  head: () => pageHead("Clients", "AKIVA admin: customer profiles, points of contact and linked contracts.", "/admin/clients", true),
  component: ClientsPage,
});
